import { z } from 'zod';
import { TIMEOUT_HOOK_PERMISSAO_S } from '../permissoes';

/**
 * Consulta de release do daemon.
 *
 * Este schema existia aqui, morto, enquanto o controller declarava o dele
 * inline — e os dois já tinham divergido: a resposta prometia `sha256` e a
 * rota devolve `somas`, que é o endereço do `SHA256SUMS` inteiro (a assinatura
 * cobre o arquivo de somas, não cada pacote). Agora é um só, e o controller
 * declara o retorno com o tipo — assim o compilador reclama antes de a
 * divergência nascer de novo.
 */
export const VersaoAgenteSchema = z.object({
  papel: z.enum(['pc', 'vps']).default('pc'),
  so: z.enum(['win32', 'linux', 'darwin']).default('linux'),
});
export type VersaoAgente = z.infer<typeof VersaoAgenteSchema>;

/** Tudo nulo quando não há release publicada: o daemon simplesmente não sobe. */
export const RespostaVersaoAgenteSchema = z.object({
  versao: z.string().nullable(),
  nome: z.string().nullable(),
  url: z.url().nullable(),
  somas: z.url().nullable(),
  assinatura: z.url().nullable(),
});
export type RespostaVersaoAgente = z.infer<typeof RespostaVersaoAgenteSchema>;

/** Porta do servidor de hooks do daemon; só escuta em 127.0.0.1. */
export const PORTA_GANCHOS_PADRAO = 47831;

/**
 * Eventos de hook que o daemon instala no settings.json do Claude Code, com o
 * timeout em segundos de cada um. Esta lista é a FONTE ÚNICA: o `mesclar.ts`
 * do daemon deriva daqui — as duas listas já divergiram uma vez e o desvio
 * ficou invisível por semanas.
 *
 * PermissionRequest é o único longo, e desde o ADR-0009 ele é também o único
 * canal de DECISÃO da sessão observada: o servidor segura a resposta enquanto
 * o painel decide, e no REPL o prompt local corre em paralelo — vale quem
 * responder primeiro. Falha, timeout ou resposta inválida deixam o Claude
 * Code seguir: fail-open, sempre.
 */
export const GANCHOS_INSTALADOS: Array<{ evento: string; timeout: number; matcher?: string }> = [
  { evento: 'SessionStart', timeout: 5 },
  { evento: 'SessionEnd', timeout: 2 },
  { evento: 'UserPromptSubmit', timeout: 5 },
  { evento: 'PostToolUse', timeout: 5, matcher: 'Edit|Write|NotebookEdit|Bash|MultiEdit' },
  { evento: 'PermissionRequest', timeout: TIMEOUT_HOOK_PERMISSAO_S },
  { evento: 'PermissionDenied', timeout: 2 },
  { evento: 'Notification', timeout: 2 },
  { evento: 'Stop', timeout: 2 },
];
